import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { DashboardPage } from "@/modules/dashboard";
import { requireAuthAndPermission } from "@/utils";

export const Route = createFileRoute("/")({
  component: Index,
  beforeLoad: requireAuthAndPermission
});

// eslint-disable-next-line react-refresh/only-export-components
function Index() {
  return (
    <>
      <DocumentTitle
        title="Dashboard"
        description="Overview of your sales, orders, and performance on the LAMPU Marketplace."
      />
      <DashboardPage />
    </>
  );
}
